import {
  Badge,
  Center,
  Flex,
  FormProvider,
  GridItem,
  SimpleGrid,
  Spinner,
  Stack,
} from '@agrotoken-tech/ui';
import { PLEDGE_SECTION_STATUSES_ICON } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { FormSection } from '../../shared';
import FarmDataForm from './components/FarmDataForm';
import FarmPropietaryDataForm from './components/FarmPropietaryDataForm';
import LotsDataForm from './components/LotsDataForm';
import {
  CropPledgeFarmProvider,
  useCropPledgeFarmContext,
} from './context/CropPledgeFarmInformationContext';

import { CropPledgeSectionActions } from '../../shared/CropPledgeSectionActions';

const PledgeFarmInformationSection = () => {
  const { t } = useTranslation();
  const {
    data,
    isLoading,
    isLoadingProvinces,
    cropPledgeSectionsStatusBadgeColors,
    formMethods,
    onSubmit,
    isPendingRequestApproval,
    approveSection,
    isPendingSectionApproval,
    farmInfoStatus,
  } = useCropPledgeFarmContext();

  if (isLoading || isLoadingProvinces || !data) {
    return (
      <Center mt="8">
        <Spinner />
      </Center>
    );
  }

  const {
    formState: { isDirty },
  } = formMethods;

  return (
    <Flex flexDir={'column'}>
      <FormSection
        title={t('cropPledgeDetail.asideNav.fieldData')}
        badge={
          <Badge
            icon={PLEDGE_SECTION_STATUSES_ICON[farmInfoStatus]}
            colorScheme={cropPledgeSectionsStatusBadgeColors[farmInfoStatus]}
            mr="2"
            iconPosition="leading"
          >
            {t(`cropPledge.section.status.${farmInfoStatus}`)}
          </Badge>
        }
      >
        <FormProvider {...formMethods}>
          <Stack mt={6} gap={6}>
            <SimpleGrid columns={2} spacing={6}>
              <FarmDataForm />
              <GridItem colSpan={2} />
              <FarmPropietaryDataForm />
              <GridItem colSpan={2} />
              <LotsDataForm />
            </SimpleGrid>
            <CropPledgeSectionActions
              isFormDirty={isDirty}
              sectionStatus={farmInfoStatus}
              onRequestApproval={onSubmit}
              isPendingRequestApproval={isPendingRequestApproval}
              onApprove={() => approveSection()}
              isPendingApprove={isPendingSectionApproval}
            />
          </Stack>
        </FormProvider>
      </FormSection>
    </Flex>
  );
};

const PledgeFarmInformation = () => {
  return (
    <CropPledgeFarmProvider>
      <PledgeFarmInformationSection />
    </CropPledgeFarmProvider>
  );
};

export default PledgeFarmInformation;
